import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

/** One rendered PDF page image (fetched with auth) with absolutely positioned overlays in % of the page. */
export function PageImage({ api, path, n, children, onMouseDown, innerRef, testid }) {
  const [url, setUrl] = useState(null);
  useEffect(() => { let u; let live = true; api.blobUrl(path).then((x) => { u = x; if (live) setUrl(x); }).catch(() => {}); return () => { live = false; if (u) URL.revokeObjectURL(u); }; }, [api, path]);
  return (
    <div data-testid={testid || `doc-page-${n}`} ref={innerRef} onMouseDown={onMouseDown} className="relative w-full bg-white shadow-lg select-none">
      {url ? <img src={url} alt={`Page ${n + 1}`} draggable={false} className="w-full block pointer-events-none" />
        : <div className="aspect-[1/1.414] flex items-center justify-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin" /></div>}
      {url && children}
    </div>
  );
}

export const boxStyle = (f) => ({ left: `${f.x * 100}%`, top: `${f.y * 100}%`, width: `${f.w * 100}%`, height: `${f.h * 100}%` });
export const SCRIPT_KEYS = new Set(["signature", "pmc_william", "pmc_heather", "pmc_andrew"]);
